<template>
  <van-popup
    v-model="show"
    class="popup"
    :class="[position, ...classArr]"
    :style="customStyle"
    :close-on-click-overlay="canOverlay"
    :position="position"
    :round="round"
    @closed="$emit('closed')"
  >
    <div class="white title font-w-b van-ellipsis" v-if="title">
      {{ title }}
    </div>
    <img
      class="off-img"
      @click="show = false"
      :src="setImgUrl('/ic_close.png')"
      v-if="isoff"
    />
    <slot></slot>
  </van-popup>
</template>

<script>
export default {
  naem: "",
  data() {
    return {
      show: this.value,
    };
  },
  watch: {
    value(val) {
      this.show = val;
    },
    show(val) {
      this.$emit("input", val);
    },
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    canOverlay: {
      type: Boolean,
      default: true,
    },
    position: {
      type: String,
      default: "center",
    },
    round: {
      type: Boolean,
      default: false,
    },
    isoff: {
      type: Boolean,
      default: true,
    },
    customStyle: {
      type: Object,
    },
    classArr: {
      type: Array,
    },
  },
};
</script>

<style lang="less" scoped>
.center {
  padding: 32px;
  border-radius: 16px;
  background: #002748;
  min-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .off-img {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 32px;
    height: 32px;
    cursor: pointer;
  }
}

.title {
  font-size: 20px;
  margin-bottom: 32px;
  justify-content: center;
  color: #e6e9ed;
  color: var(--Gray_05);
  flex-shrink: 0;
}

.big-pop {
  padding: 0;
  width: 640px;

  .off-img {
    top: 13px;
  }

  .title {
    height: 57px;
    line-height: 57px;
    max-width: calc(100% - 128px);
    margin: 0 64px;
  }
}

@media screen and (max-width: 768px) {
  .title {
    //font-size: 1.25rem;
  }

  .center{
    .off-img{
      //width: 2rem;
      //height: 2rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PopupPC.vue